import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-students-results',
  templateUrl: './students-results.component.html',
  styleUrls: ['./students-results.component.scss']
})
export class StudentsResultsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
